export enum STICKY_CLASS_NAMES {
    SHOW_STICKY = 'sticky-visible',
    HIDE_STICKY = ''
}
